/**
 * @name JobService
 * @description Servicio para gestionar de Puestos
 * @author Alexis Becerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Administración Endpoint
const BASE_URL = `${Environment.getCurrent().endpoints.admin}`;

/**
 * Consulta la lista de puestos de una empresa
 * @return {any} promise 
 */
const getData = () => {
    let URL = `${BASE_URL}/Puesto?paginado=1,2000&columnas=IdPuesto,Puesto`;
    return axios.get(URL).then(({ data }) => {

        let array = data.map(item => {
            return { IdPuesto: item.IdPuesto, Nombre: item.Puesto };
        });

        return array;
    });
};

export const JobService = {
    getData,
};